import { getApolloClient } from '../lib/getApolloClient';
import { handleError } from '../util/utils';
import { GET_THEME } from './theme.rest';

const fetchTheme = async (tenantId: string, appContext: string) => {
  try {
    const result = await getApolloClient(true).query({
      query: GET_THEME,
      variables: {
        tenantId,
        type: appContext,
      },
    });
    if (result.data.theme) {
      return result.data.theme;
    }
    return null;
  } catch (error) {
    handleError(error, 'Error in getTheme');
    return null;
  }
};

export const themeActions = {
  fetchTheme,
};
